import {Component, OnInit, OnDestroy} from '@angular/core';
import {AuthAccessProvider} from '../core/core.auth';
import {Router} from '@angular/router';
import {UserContext, BaseComponent, UserDataResponse, UserData, User} from '../core/core.component';
import {MessageProvider} from '../service/message.service';
import {UserService} from '../service/user.service';
import {Subscription} from 'rxjs/Subscription';
import {Message} from 'primeng/components/common/api';

declare var $: any;

@Component({
  selector: 'app-userdata',
  templateUrl: './userdata.component.html',
  styleUrls: ['./userdata.component.css']
})

export class UserDataComponent extends BaseComponent implements OnInit, OnDestroy {

  static DIALOG_ID: string = 'UserDataDialog';
  userContext: UserContext = null;
  user: User = null;
  userData: UserData = new UserData();
  errorMessage: string = null;
  validationMessage: string = null;
  loading: boolean = false;
  today: Date = new Date();
  private subscriptions: Subscription[] = [];

  msgs: Message[] = [];

  constructor(protected authAccess: AuthAccessProvider,
    protected router: Router,
    protected messageProvider: MessageProvider,
    private userService: UserService) {
    super(authAccess, router, messageProvider);
  }

  ngOnDestroy() {
    if (this.subscriptions != null) {
      for (let i = 0; i < this.subscriptions.length; ++i) {
        this.subscriptions[i].unsubscribe();
      }
    }
  }

  ngOnInit() {
    this.userContext = this.authAccess.getUserContext();
    if (this.userContext == null) {
      this.authAccess.invalidate();
    } else {
      this.subscriptions[0] = this.userService.getUserDataComponentStatus().subscribe(
        user => {
          if (user != null) {
            this.user = user;
            $('#' + UserDataComponent.DIALOG_ID).modal({backdrop: 'static', keyboard: false});
            this.load();
          } else {
            this.close();
          }
        }
      );
    }
  }

  private load() {
    this.errorMessage = null;
    this.loading = true;
    this.userService.getUserData(this.userContext.srmToken, this.user.id).subscribe(
      result => {
        if (result != null) {
          this.userData = result.userData;
        }
        this.loading = false;
      },
      error => {
        this.errorMessage = this.retrieveError(error);
        this.loading = false;
      }
    );
  }

  storeUserData() {
      if (this.userData.numGiorniFerieAnno < 1) {
        this.validationMessage = "Inserire un valore di N° giorni ferie valido";
        return;
      }
      if (!this.isNumOreLavValido(this.userData.numOreLun) || !this.isNumOreLavValido(this.userData.numOreMar) || !this.isNumOreLavValido(this.userData.numOreMer)
          || !this.isNumOreLavValido(this.userData.numOreGio) || !this.isNumOreLavValido(this.userData.numOreVen) 
          || !this.isNumOreLavValido(this.userData.numOreSab) || !this.isNumOreLavValido(this.userData.numOreDom)) {
        this.validationMessage = "Inserire valori di N° ore lavorative validi";
        return;
      }
      this.userService.updateUserData(this.userContext.srmToken, this.user.id, this.userData).subscribe(
        result => {
          this.msgs = [];
          this.msgs.push({severity:'success', summary:'OK', detail:'Modifica eseguita correttamente'});
        },
        error => {
          this.errorMessage = this.retrieveError(error);
        }
      );
  }
  
  isNumOreLavValido(ore) {
  	return (ore || ore == 0) && ore > -1 && ore < 14 && ore % 1 == 0;
  }

  close() {
    $('#' + UserDataComponent.DIALOG_ID).modal('hide');
    this.user = null;
    this.userData = new UserData();
    this.errorMessage = null;
  }
}



// WEBPACK FOOTER //
// ./src/app/userdata/userdata.component.ts